import React, { useState, useEffect } from "react";
import { 
  CheckCircle2, 
  AlertCircle, 
  Clock, 
  Activity, 
  Database, 
  ShieldCheck, 
  Wifi, 
  Zap,
  ArrowLeft
} from "lucide-react";
import { Link } from "react-router-dom";
import FooterSection from "../components/FooterSection";
import "./Status.css";

const Status = () => {
  const [loading, setLoading] = useState(true);

  // Simulated health check
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  const services = [
    { name: "Firebase Authentication", status: "operational", icon: <ShieldCheck size={20} />, latency: "42ms" },
    { name: "Realtime Database", status: "operational", icon: <Database size={20} />, latency: "18ms" },
    { name: "Cloud Storage", status: "operational", icon: <Activity size={20} />, latency: "124ms" },
    { name: "IoT Gateway (Live Vitals)", status: "operational", icon: <Wifi size={20} />, latency: "2ms" },
    { name: "AI Insight Engine", status: "degraded", icon: <Zap size={20} />, latency: "850ms" },
  ];

  return (
    <div className="status-page">
      <div className="status-container">
        <header className="status-header">
          <Link to="/" className="back-home">
            <ArrowLeft size={18} />
            <span>Back to Medico.in</span>
          </Link>
          <div className="status-banner operational">
            <CheckCircle2 size={32} />
            <div className="banner-text">
              <h1>All Systems Operational</h1>
              <p>Updated 1 minute ago</p>
            </div>
          </div>
        </header>

        <main className="status-main">
          {/* Services Grid */}
          <section className="services-section">
            <h2 className="section-title">Current Service Status</h2>
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className={`service-card glass-card ${service.status}`}>
                  <div className="service-info">
                    <span className="service-icon">{service.icon}</span>
                    <span className="service-name">{service.name}</span>
                  </div>
                  <div className="service-status-meta">
                    <span className="latency">{service.latency}</span>
                    <span className={`status-pill ${service.status}`}>
                      {service.status === "operational" ? "Operational" : "Degraded"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Uptime History */}
          <section className="uptime-section">
            <div className="section-header">
              <h2 className="section-title">Uptime History</h2>
              <span className="uptime-percentage">99.98% overall uptime</span>
            </div>
            <div className="uptime-history glass-card">
              <div className="history-header">
                <span>Last 90 Days</span>
                <span className="history-meta">Region: Global</span>
              </div>
              <div className="uptime-bar">
                {[...Array(60)].map((_, i) => (
                  <div 
                    key={i} 
                    className={`uptime-tick ${i === 42 ? 'warning' : 'green'}`}
                    title={i === 42 ? "March 12: Slight latency increase" : "Operational"}
                  ></div>
                ))}
              </div>
              <div className="history-footer">
                <span>90 days ago</span>
                <span>Today</span>
              </div>
            </div>
          </section>

          {/* Past Incidents */}
          <section className="incidents-section">
            <h2 className="section-title">Past Incidents</h2>
            <div className="incidents-list glass-card">
              <div className="incident-item">
                <div className="incident-date">March 28, 2026</div>
                <div className="incident-content">
                  <h4>Scheduled Maintenance: Database Optimization</h4>
                  <p>Resolved - The scheduled maintenance has been completed successfully. No downtime was observed during this window.</p>
                </div>
              </div>
              <div className="incident-item">
                <div className="incident-date">March 14, 2026</div>
                <div className="incident-content">
                  <h4>Brief Degraded Performance - IoT Gateway</h4>
                  <p>Resolved - High traffic volume caused a temporary increase in data processing latency. Scaled gateway capacity to resolve.</p>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <FooterSection />
    </div>
  );
};

export default Status;
